export default "__VITE_ASSET__dadc08e3__"